import React from "react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";

import { useState, useEffect } from "react";
interface IProps {
  defaultName?: string;
  options: any;
  Value?: any;
  onChnage: (name: any) => void;
  zIndex?: any;
  placeHolder?: any;
  loading?: any;
  handleAddToList?: any;
  isAdded: any;
  onKeyDown?: any;
  clearFields?: boolean
  onInputChange?: any
}

export default function CustomAutocomplete({
  defaultName = "",
  options,
  Value,
  onChnage,
  zIndex,
  placeHolder,
  loading,
  handleAddToList,
  isAdded,
  onKeyDown,
  clearFields,
  onInputChange
}: IProps) {
  const [inputValue, setInputValue] = useState(Value?.Name);
  const [selectedValue, setSelectedValue] = useState(Value || null);
  const [isValueSelected, setIsValueSelected] = useState(false);
  // Reset input field and selected value when `isAdded` is true
  useEffect(() => {
    if (isAdded || clearFields) {
      setInputValue("");
      setSelectedValue(null);
      setIsValueSelected(false);
    }
  }, [isAdded, clearFields]);

  // Update `selectedValue` whenever `Value` changes
  useEffect(() => {
    if (Value) {
      setSelectedValue(Value);
    }
  }, [Value]);

  // Update `selectedValue` whenever `Value` changes
  useEffect(() => {
    if (Value) {
      setSelectedValue(Value);
    }
  }, [Value]);
  return (
    <div>
      <Autocomplete
        defaultValue={defaultName || ""}
        size="small"
        sx={{
          "& .MuiInputBase-root": {
            height: "40px",
            width: "100%",
          },
        }}
        options={options || []}
        getOptionLabel={(option) => {
          // Ensure it handles both object-based options and empty values gracefully
          return typeof option === "object" && option?.Name
            ? `${option.Name} ${option.dose || ""}`.trim()
            : "";
        }}
        value={
          selectedValue
        }
        onChange={(e, newValue) => {
          setSelectedValue(newValue);
          onChnage(newValue);
          // Reset input value when a new option is selected

          if (newValue) {
            setIsValueSelected(true);
            setInputValue("");
          }


        }}
        inputValue={Value?.Name ? Value.Name : inputValue}
        onInputChange={(e, newInputValue) => {
          // Allow input change only if `isAdded` is false and if no valid selected value
          onInputChange?.(newInputValue)
          if (!isAdded || !selectedValue || !selectedValue.Name) {
            setInputValue(newInputValue);
            setIsValueSelected(false);
          }


        }}
        renderInput={(params: any) => (
          <TextField
            {...params}
            placeholder={placeHolder || ""}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
            onKeyDown={(e) => {
              // Check if the Enter key is pressed
              if (e.key === "Enter") {
                e.preventDefault();

                // If a valid item is selected, don't call handleAddToList
                if (isValueSelected && inputValue) {
                  // Call handleAddToList with the typed value
                  if (handleAddToList) {
                    handleAddToList(inputValue);
                  }
                }
              }
              // Allow external onKeyDown functionality if provided
              if (onKeyDown) {
                onKeyDown(e);
              }
            }}
          />
        )}
        freeSolo
        slotProps={{
          popper: {
            sx: {
              zIndex: zIndex || 7000,
            },
          },
        }}
        renderOption={(props, option) => (
          <li {...props}>
            <span>{option.Name}</span>
            <span>&nbsp;</span>
            <span
              style={{
                fontSize: "10px",
                position: "relative",
                bottom: 9,
                right: 1,
              }}
            >
              {option.dose}
            </span>
          </li>
        )}
      />
    </div>
  );
}
